import deepEqual from "fast-deep-equal";
function getNotEmptyFieldsCount(obj) {
    return obj
        ? Object.values(obj).filter((value) => {
            if (value === null || value === undefined || value === "")
                return false;
            else if (Array.isArray(value) && !value.length)
                return false;
            return true;
        }).length
        : 0;
}
function getFirstKeyValue(obj) {
    return obj
        ? obj[Object.getOwnPropertyNames(obj)[0]]
        : undefined;
}
function getFirstPrimitiveValue(obj, targetType) {
    let result = getFirstKeyValue(obj);
    let type = typeof result;
    while (result && type !== targetType && type === "object") {
        result = getFirstKeyValue(result);
        type = typeof result;
    }
    return type === targetType ? result : null;
}
export default {
    getNotEmptyFieldsCount,
    getFirstKeyValue,
    getFirstPrimitiveValue,
    compare: deepEqual,
};
//# sourceMappingURL=object.js.map